import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex);

const state = {
    menus: [],
    submenus: [],
    image: '',
}

const actions = {
    getMenus({commit}) {
        return new Promise((resolve, reject) => {
            axios.get('/api/admin-menu-items').then((response) => {
                commit('setMenus', response.data);
                resolve(response.data);
            }).catch((e) => {
                console.log('unable to get menus', e);
                reject(e);
            })
        });
    },
    getSubmenus({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios.get('/api/admin-sub-menu-items/'+payload.parent_id).then((response) => {
                commit('setSubmenus', response.data);
                resolve(response.data);
            }).catch((e) => {
                console.log('unable to get submenus', e);
                reject(e);
            })
        });
    },
}

const mutations = {
    setMenus(state, payload) {
        state.menus = payload;
    },
    setSubmenus(state, payload) {
        state.submenus = payload;
    },
    setImage(state, payload) {
        state.image = payload;
    },
}

const getters = {
    menuList: state => state.menus,
    submenuList: state => state.submenus ? state.submenus : [],
    image: state => state.image,
}

export const commonStore = {
    state,
    actions,
    mutations,
    getters
}